import { render } from "./Qualification.vue?vue&type=template&id=2c31f088"
import script from "./Qualification.vue?vue&type=script&lang=js"
export * from "./Qualification.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__